

const AddDocument = () => {
    return(
        <>ADD Document</>
    );
}

export default AddDocument;